import { Route, Routes } from "react-router";
import "../src/scss/tipperUiSection/tipperCommon.scss";
import "./App.css";
import TippingPayment from "./pages/tippingUiSection";
import GuestyIntegration from "./pages/tippingUiSection/guestyIntegration";
import OrderDelievered from "./pages/tippingUiSection/orderDelievered";
import PaymentDone from "./pages/tippingUiSection/paymentDone";
import Error from "./pages/tippingUiSection/redirectPages/Error";
import NotFound from "./pages/tippingUiSection/redirectPages/NotFound";
import Success from "./pages/tippingUiSection/redirectPages/Success";
import { useEffect } from "react";

// Hotjar type declarations
declare global {
  interface Window {
    hj: ((...args: any[]) => void) & {
      q: any[];
    };
    _hjSettings: {
      hjid: number;
      hjsv: number;
    };
  }
}

function App() {
  // useEffect(() => {
  //   clearCacheOnVersionChange(); // Run cache manager on app load
  // }, [])

  // useEffect(() => {
  //   if (process.env.REACT_APP_HOTJAR_ID) {
  //     const hotjarId = process.env.REACT_APP_HOTJAR_ID;

  //     (function (h: Window, o: Document, t: string, j: string, a: HTMLHeadElement | undefined, r: HTMLScriptElement | undefined) {
  //       h.hj = h.hj || function () {
  //         (h.hj.q = h.hj.q || []).push(arguments);
  //       };
  //       h._hjSettings = { hjid: Number(hotjarId), hjsv: 6 };
  //       a = o.getElementsByTagName('head')[0];
  //       r = o.createElement('script');
  //       if (r) {
  //         r.async = true;
  //         r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  //         if (a) {
  //           a.appendChild(r);
  //         }
  //       }
  //     })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=', undefined, undefined);
  //   }
  // }, []);

  return (
    <>
      <Routes>
        <Route
          path="/guesty?/:token1?/:token2?/c?/org?"
          element={<TippingPayment />}
        />
        <Route path="/error" element={<Error />} />
        <Route path="/not-found" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/success" element={<Success />} />

        <Route path="/payment-confirm" element={<OrderDelievered />} />
        <Route path="/payment-completed" element={<PaymentDone />} />

        <Route path="/guesty-partner" element={<GuestyIntegration />} />
        {/* <Route path="image-loader" element={<StripeSkeleton />} /> */}
      </Routes>
    </>
  );
}

export default App;
